import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbDatepickerModule, NgbTooltipModule, NgbModalModule, NgbDateParserFormatter, NgbTimepickerModule, NgbTabsetModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GeneralCalculatorComponent } from './general-calculator/general-calculator.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { RecommendationsComponent } from './recommendations/recommendations.component';
import { OffersComponent } from './offers/offers.component';
import { DocumentsComponent } from './documents/documents.component';
import { LoginComponent } from './login/login.component';
import { UserAuthInterceptor } from './app.interceptor';
import { NgbDateCustomParserFormatter } from './shared/custom-parser';
import { SignDocumentsComponent } from './sign-documents/sign-documents.component';
import { SignOnTheSpotComponent } from './sign-on-the-spot/sign-on-the-spot.component';
import { UploadDocumentsComponent } from './upload-documents/upload-documents.component';

import { registerLocaleData } from '@angular/common';
import localeSr from '@angular/common/locales/sr';
import { AdminPanelModule } from './admin-panel/admin-panel.module';
import { CalculatorsModule } from './calculators/calculators.module';
import { ReportPanelModule } from './report-panel/report-panel.module';
import { QuestionnairePanelModule } from './questionnaire-panel/questionnaire-panel.module';
registerLocaleData(localeSr, 'sr');


@NgModule({
  declarations: [
    AppComponent,
    GeneralCalculatorComponent,
    NavigationBarComponent,
    AppointmentsComponent,
    RecommendationsComponent,
    OffersComponent,
    DocumentsComponent,
    LoginComponent,
    SignDocumentsComponent,
    SignOnTheSpotComponent,
    UploadDocumentsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    NgbModalModule,
    NgbTimepickerModule,
    NgbTabsetModule,
    NgbPaginationModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    SignaturePadModule,
    PdfViewerModule,
    NgMultiSelectDropDownModule.forRoot(),
    LoadingBarHttpClientModule,
    AdminPanelModule,
    CalculatorsModule,
    ReportPanelModule,
    QuestionnairePanelModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserAuthInterceptor,
      multi: true
    },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
